import type { NavGroup, NavItem, Zone } from './zone';

/** Mục đang mở = mục có `to` khớp dài nhất với đường dẫn (khớp nguyên đoạn). */
export function activeKey(zone: Pick<Zone, 'top' | 'nav'>, path: string): string | null {
  const p = trim(path);
  let best: NavItem | null = null;
  for (const it of allItems(zone)) {
    const t = trim(it.to);
    if ((p === t || p.startsWith(t + '/')) && (!best || t.length > trim(best.to).length)) best = it;
  }
  return best?.key ?? null;
}

const trim = (s: string) => (s.length > 1 ? s.replace(/\/+$/, '') : s);

export function allItems(zone: Pick<Zone, 'top' | 'nav'>): NavItem[] {
  return [...(zone.top ?? []), ...zone.nav.flatMap((g) => g.items)];
}

export function groupOf(zone: Pick<Zone, 'nav'>, key: string | null): NavGroup | undefined {
  return key ? zone.nav.find((g) => g.items.some((i) => i.key === key)) : undefined;
}

export const sum = (g: NavGroup) => g.items.reduce((a, i) => a + (i.n ?? 0), 0);

/** Tab dưới của điện thoại: zone.tabs, không có thì top + mục đầu của các nhóm, tối đa 4 (ô thứ 5 là "Thêm"). */
export function phoneTabs(zone: Zone): NavItem[] {
  if (zone.tabs?.length) return zone.tabs.slice(0, 4);
  const fromGroups = zone.nav.flatMap((g) => (g.items[0] ? [{ ...g.items[0], key: g.items[0].key, label: g.label, icon: g.icon ?? g.items[0].icon }] : []));
  return [...(zone.top ?? []), ...fromGroups].slice(0, 4);
}

/** Tìm nhanh trong menu: không dấu, mọi từ phải khớp. */
export function findItems(zone: Zone, q: string): (NavItem & { group?: string })[] {
  const n = norm(q);
  const rows: (NavItem & { group?: string })[] = [...(zone.top ?? []).map((i) => ({ ...i })), ...zone.nav.flatMap((g) => g.items.map((i) => ({ ...i, group: g.label })))];
  if (!n) return rows;
  const words = n.split(/\s+/);
  return rows.filter((r) => {
    const hay = norm(`${r.label} ${r.group ?? ''}`);
    return words.every((w) => hay.includes(w));
  });
}

export const norm = (s: string) =>
  s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').trim();

export const initials = (n: string) =>
  n
    .split(/\s+/)
    .filter(Boolean)
    .slice(-2)
    .map((w) => w[0]?.toUpperCase())
    .join('') || '?';

/** Link của TanStack tự gắn aria-current cho mọi đường dẫn cha; khung tự tính mục đang mở nên chỉ cho khớp đúng. */
export const EXACT = { exact: true } as const;
